import { useState } from "react";
import emailjs from "@emailjs/browser";
import { useTranslation } from "react-i18next";

const ContactForm = () => {
  const {t} = useTranslation();
  // const [status, setStatus] = useState(t('contactUs.submit'));
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [query, setQuery] = useState("");

  const sendMail = () => {
    const params = {
      name,
      email,
      phone,
      message: query,
    };
    const serviceID = process.env.REACT_APP_SERVICE_ID;
    const templateID = process.env.REACT_APP_TEMPLATE_ID;
    const userID = process.env.REACT_APP_USER_ID;

    emailjs.send(serviceID, templateID, params, userID).then(
      (response) => {
        console.log("SUCCESS!", response.status, response.text);
        // setStatus(t('contactUs.submit'));
        alert("Your message has been sent successfully!");

        // Clear input fields after successful submission
        setName("");
        setEmail("");
        setPhone("");
        setQuery("");
      },
      (error) => {
        console.log("FAILED...", error);
        // setStatus(t('contactUs.submit'));
        alert("Something went wrong. Please try again later.");
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // setStatus(`${t('contactUs.sending')}...`);

    sendMail();
  };

  return (
    <div className="p-5 contact-us-wrapper">
      {/* <div className="form-overlay"></div> */}
      <div className="contact-form text-center">
        <p className="lead font fw-bold mb-5">{t('contactUs.requestConsultation')}</p>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-12">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                {t('contactUs.name')}:
              </label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="form-control"
                required
              />
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="email" className="form-label pt-2">
                  {t('contactUs.email')}:
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-control"
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="phone" className="form-label pt-2">
                  {t('contactUs.phone')}:
                </label>
                <input
                  type="tel"
                  id="phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="form-control"
                  required
                />
              </div>
            </div>

            <div className="mb-3">
              <label htmlFor="query" className="form-label pt-2">
                {t('contactUs.message')}:
              </label>
              <textarea
                className="form-control"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                id="query"
                rows={5}
                required
              ></textarea>
            </div>

            <div className="my-4 text-end pt-2">
              <button
                type="submit"
                className="btn btn-outline-secondary"
                aria-label={t('contactUs.submit')}
              >
                {t('contactUs.submit')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
